import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Compact "ⓘ" hover — replaces static info paragraphs to save screen space
export const InfoTip = ({ children, side = "right", className = "" }) => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center text-slate-400 hover:text-blue-600 transition-colors align-middle ${className}`}
          data-testid="info-tip"
          onClick={(e) => e.preventDefault()}
        >
          <Info className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed whitespace-pre-line">
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
